import * as React from "react";
import { Tab, Tabs } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { LogsStore } from "../../stores/logs/LogsStore";
import { AppStore } from "../../stores/AppStore";
import LogsSistema from "./sistema";
import LogsEmpresas from "./empresas";
import LogsDeclaracoes from "./declaracoes";
import LogsXmls from "./xmls";
import LogsCalculos from "./calculos";
import LogsSped from "./sped";
import LogsPerfil from "./perfil";
import LogsLogin from "./login";
import LogsAdmin from "./admin";
import LogsRelatorios from "./relatorios";
import LogsCaixapostal from "./caixa_postal";

@observer
export default class LogsPage extends React.Component<{}, {}> {

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Logs");
  }

  handleChangeTab(tab: string) {
    LogsStore.obs.logs = []
    LogsStore.obs.detalhesLog = []
    LogsStore.obs.modulo = tab
    LogsStore.obs.filter = ""
    LogsStore.obs.filter_cnpj = ""
    LogsStore.obs.component = "selecione"
  }

  render() {
    return (
      <Tabs
        id="tabs"
        className={"tabsCalculos"}
        selectedTabId={LogsStore.obs.modulo}
        onChange={(tabId) => this.handleChangeTab(String(tabId))}
      >
        <Tab
          id="sistema"
          title="Sistema"
          panel={<LogsSistema />}
        />

        <Tab
          id="empresas"
          title="Empresas"
          panel={<LogsEmpresas />}
        />

        <Tab
          id="declaracoes"
          title="Declarações"
          panel={<LogsDeclaracoes />}
        />

        <Tab
          id="xmls"
          title="XMLs"
          panel={<LogsXmls />}
        />

        <Tab
          id="calculos"
          title="Cálculos"
          panel={<LogsCalculos />}
        />

        <Tab
          id="sped"
          title="Sped"
          panel={<LogsSped />}
        />

        <Tab
          id="relatorios"
          title="Relatórios"
          panel={<LogsRelatorios />}
        />

        <Tab
          id="perfil"
          title="Perfil"
          panel={<LogsPerfil />}
        />

        <Tab
          id="login"
          title="Login"
          panel={<LogsLogin />}
        />

        <Tab
          id="caixapostal"
          title="Caixa Postal"
          panel={<LogsCaixapostal />}
        />

        {AppStore.obs1.usuario.admin &&
          <Tab
            id="admin"
            title="Admin"
            panel={<LogsAdmin />}
          />

        }
      </Tabs>
    );
  }
}
